<template>
  <div class="container">
    <router-view ref="container"></router-view>
  </div>
</template>

<script>
export default {
  name: "container",
  mounted() {
    document.getElementsByClassName("header-menu-container")[0].style.display =
      "none";
  },
};
</script>

<style lang="scss" scoped>
.container {
  background: #edf1f7;
  height: 100%;
}
</style>
